// components/SwEventDrawer/components/AccessSlotsSection.jsx
import React from 'react';
import SpInput from '../../SpInput/SpInput';

const AccessSlotsSection = ({ 
  formik, 
  getActiveAccessTypes, 
  handleAccessSlotChange, 
  getFieldError 
}) => {
  return (
    <div className="sw-event-modal-section">
      <div className="sw-event-section-header">
        Access Slots
      </div>
      
      {getActiveAccessTypes().map((accessType) => (
        <div key={accessType} className="sw-access-slot-input">
          <SpInput
            label={accessType}
            placeholder="Enter number of slots"
            type="number"
            value={formik.values.accessSlots[accessType] || ''}
            onChange={(e) => handleAccessSlotChange(accessType, e.target.value)}
            onBlur={() => formik.setFieldTouched(`accessSlots.${accessType}`, true)}
            error={getFieldError(`accessSlots.${accessType}`)}
            required
          />
        </div>
      ))}
      
      {getActiveAccessTypes().length === 0 && (
        <div className="sw-no-access-types">
          <p style={{ color: '#999', fontStyle: 'italic' }}>
            Add access types above to configure slots
          </p>
        </div>
      )}
    </div>
  );
};

export default AccessSlotsSection;